import { PopoverProps } from '@ubnt/ui-components/Popover/Popover';
import PopoverCard from '@ubnt/ui-components/Popover/PopoverCard';
import { memo, useCallback } from 'react';

import DefaultHeader from 'components/ui-components/DefaultSidePanelHeader';
import { settingsToggleVisibility } from 'modules/settings/slice';
import { useDispatch } from 'app/store';

import classes from './SettingsPopoverContent.module.scss';

export type RenderCardProps = Parameters<NonNullable<PopoverProps['renderCard']>>['0'];

const SettingsPopoverContentImpl = (props: RenderCardProps) => {
  const { children, togglePopover, ...rest } = props;
  const dispatch = useDispatch();
  const onClose = useCallback(() => {
    togglePopover?.();
    dispatch(settingsToggleVisibility());
  }, [dispatch, togglePopover]);

  return (
    <PopoverCard {...rest} className={classes.popover}>
      <div className={classes.panelHeader}>
        <DefaultHeader onClose={onClose}>Display Options</DefaultHeader>
        {children}
      </div>
    </PopoverCard>
  );
};

const SettingsPopoverContent = memo(SettingsPopoverContentImpl);

export default SettingsPopoverContent;
